//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MenuItem from "./MenuItem";
export default {
  components: {
    MenuItem
  },
  props: {
    navLinks: {
      type: Array,
      required: true,
    },
    right: {
      type: Boolean,
      required: false,
      default: false
    },
    mainMenu: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggleInnerMenu () {

    }
  },
}
